import { useState, useReducer, createContext, useMemo } from 'react'

const SignUpContext = createContext()

export const SignUpProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState({
    device_name: 'website',
    is_host: false,
    host_type: '',
    email: '',
    name: '',
    password: '',
    password_confirmation: '',
    plan: '',
    marketing: true,
    terms: false,
    is_guest: false,
    user_uuid: ''
  })

  const value = useMemo(
    () => ({ userDetails, setUserDetails }),
    [userDetails, setUserDetails]
  )
  return (
    <SignUpContext.Provider value={value}>{children}</SignUpContext.Provider>
  )
}

export default SignUpContext
